import type { SchemaField } from '@cli-types/core-engine/schema.js'
import { quotePropertyName } from '@cli-utils/text.js'
import { renderNestedListDefaultValueContentTemplate } from '@next-adapter/templates/renderers/generators/form/form-shared/generate-nested-list-default-value.js'
import { generateNestedFieldDefaultExpression } from './generate-nested-field-default-expression.js'
import { propertyAccessExpression } from './property-access-expression.js'

export function generateNestedListDefaultValue(f: SchemaField, dataSource: string): string {
  const nestedFields = f.fields ?? []
  const values = nestedFields.flatMap((nestedField) => {
    const fieldDefault = `        ${quotePropertyName(nestedField.name)}: ${generateNestedFieldDefaultExpression(nestedField, 'item')}`
    if (!nestedField.hasIcon) return [fieldDefault]

    const iconName = `${nestedField.name}Icon`
    return [
      fieldDefault,
      `        ${quotePropertyName(iconName)}: ${propertyAccessExpression('item', iconName)} ?? ''`
    ]
  })

  if (values.length === 0) return `      ${f.name}: ${dataSource}?.${f.name} ?? []`

  return renderNestedListDefaultValueContentTemplate({
    fName: f.name,
    dataSource: dataSource,
    join: values.join(',\n')
  })
}
